export default {
    generateContentModal: {
        title: 'Tuota sisältöä',
        type: 'Tyyppi',
        typePlaceholder: 'Valitse tyyppi',
        typeEmptyError: 'Valitse tyyppi, ole hyvä',
        context: 'Konteksti',
        contextPlaceholder: 'Valitse asiayhteys',
        contextEmptyError: 'Valitse konteksti, kiitos',
        contentTitle: 'Otsikko sisällölle',
        contentTitlePlaceholder: 'Lisää sisältösi teema',
        contentTitleEmptyError: 'Ole hyvä ja syötä otsikko',
        contentTitleInvalidError: 'Syötä oikea otsikko',
        contentTitleNumberError: 'Ole hyvä ja kirjoita otsake, joka alkaa kirjaimella',
        description: 'Anna lyhyt kuvaus sisällöstä',
        descriptionPlaceholder: 'Lisää sisältösi kuvaus 2-3 rivillä',
        descriptionEmptyError: 'Syötä kuvaus',
        descriptionInvalidError: 'Syötä voimassa oleva kuvaus',
        addKeywords: 'Lisää avainsanat',
        addKeywordsEmptyError: 'Ole hyvä ja syötä avainsanat',
        writingTone: 'Kirjoitustyyli',
        writingTonePlaceholder: 'Valitse kirjoitustyyli',
        writingToneEmptyError: 'Valitse kirjoitustyyli, kiitos',
        numberOfVariations: 'Vaihtoehtojen määrä',
        numberOfVariationsEmptyError: 'Valitse vaihtoehtojen määrä, kiitos',
        numberOfVariationsInvalidError: 'Voit luoda korkeintaan 5 ja vähintään 1 muunnelmaa',
        generate: 'Tuottaa',
        additionalOptions: 'Lisäasetukset',
        clear: 'selvä',
        writingToneOptions: {
            funny: 'hauska',
            casual: 'rento',
            excited: 'Innostunut',
            professional: 'Ammattilainen',
            witty: 'Hauska',
            sarcastic: 'Sarkastinen',
            feminine: 'Naisellinen',
            masculine: 'Miehekäs',
            bold: 'rohkea',
            dramatic: 'Dramaattinen',
            grumpy: 'Muriseva',
            secretive: 'Salaperäinen',
            respectful: 'Kunnioittava',
            persuasive: 'Vakuuttava',
        },
        contextOptions: {
            promotional: 'Edistämiseen liittyvä',
            introduction: 'Johdanto',
            couponDiscount: 'Kuponki/Alennus',
            recurringNewsletter: 'Toistuva uutiskirje',
            testimonial: 'Suositus',
            coldOutreach: 'Kylmä kontaktointi',
            contentGiveaway: 'Sisältö / lahja-arpajaiset',
            other: 'Muu',
        },
        typeOptions: {
            outline: 'Ääriviiva',
            introduction: 'Johdanto',
            section: 'Osio',
        },
        customLengthOfContentPlaceholder: 'Sanojen määrä (enintään 900)',
        lengthOfContentPlaceholder: 'Valitse sisällön pituus',
        lengthOfContent: 'Sisällön pituus',
        customLengthOfContent: 'Mukautettu pituus',
        smallContent: 'Pieni',
        mediumContent: 'Keskitaso',
        largeContent: 'Suuri',
        customContentLength: 'Mukautettu pituus (50 - 900 sanaa)',
        lengthOfContentError: 'Valitse sisällön pituus, ole hyvä',
        customLengthError: 'Väärä arvo',
        lengthOfContentTooltip: 'Aseta sisällön pituus, joka generoidaan tehtävän kuvauksen perusteella',
    },
};
